import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormBreed from '../../forms/FormBreed.jsx';

const PageBreed = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({ url: `/api/site/breeds/${_id}` });
    }
  }, [_id]);

  const breadcrumb = _id === 'self' ? [] : [
    { to: '../', children: 'Breeds' },
  ];

  return _id === 'new' ? (
    <>
      <Header breadcrumb={breadcrumb}>New Breeds</Header>
      <FormBreed />
    </>
  ) : (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormBreed
            breed={doc}
          />
        </>
      )}
    </PageHttp>
  );
};

export default PageBreed;
